import * as React from 'react'

require('../base.module.scss')
import {
  BaseComponentProps,
  extractClassNamesFromProps
} from '../Common/extractClassNamesFromProps'
import * as st from './MaturityRating.module.scss'
import {BBFC_U, BBFC_PG, BBFC_12, BBFC_15, BBFC_18} from '../Icon/BBFC'

const styledRatings: {[key:string]:string[]} = {
  de: ['0', '6', '12', '16', '18'],
  uk: ['U', 'PG', '12', '15', '18']
}

export interface MaturityRatingProps extends BaseComponentProps {
  rating: string
  locale?: 'uk' | 'de'
  small?: boolean
  title?: string // This needs to be moved into BaseComponentProps
  'data-testid'?: string // This needs to be moved into BaseComponentProps
}

export class MaturityRating extends React.Component<MaturityRatingProps> {
  // Add displayName to preserve the component name on snapshot testing
  displayName = 'MaturityRating'

  render() {
    const {rating, locale, small, children, title} = this.props;
    const ratingExists = (rating: string, locale?: 'uk' | 'de') => (
      locale && styledRatings[locale] && styledRatings[locale].includes(rating)
    );
    const classNames = extractClassNamesFromProps(
      this.props,
      st.MaturityRating,
      {
        [st[`local-${locale}`]]: ratingExists(rating, locale),
        [st[`rating-${rating}`]]: ratingExists(rating, locale),
        [st.small]: Boolean(small)
      }
    )
    const bbfcRatings = (rating: string) => {
      switch (rating) {
        case 'U': return <BBFC_U />;
        case 'PG': return <BBFC_PG />;
        case '12': return <BBFC_12 />;
        case '15': return <BBFC_15 />;
        case '18': return <BBFC_18 />;
      }
    }
    return (
      <span className={classNames} title={title}
        data-testid={this.props['data-testid']} // This is the new standard
        data-automation-id={this.props['data-testid']} // This is the old standard. To be removed.
      >
        {locale === 'uk' && <>{bbfcRatings(rating)}</>}
        {locale !== 'uk' && <>{rating}{children}</>}
      </span>
    )
  }
}
